// TODO: apply these logs only for admin accounts
/* eslint-disable */

export const logMessage = (...messages: unknown[]): void => {
  console.log(...messages)
}

export const logError = (...messages: unknown[]): void => {
  console.error(...messages)
}

export const logWarn = (...messages: unknown[]): void => {
  console.warn(...messages)
}
